import { Provider } from "react-redux";
import { store } from './redux/store';
import { ToastContainer } from 'react-toastify';
import './assest/css/custom.css';
import 'cropperjs/dist/cropper.css';
import MainRoutes from './routes/MainRoutes';
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-date-picker/dist/DatePicker.css';
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import 'react-confirm-alert/src/react-confirm-alert.css';
import VConsole from "vconsole";

function App() {
    // new VConsole();
  // const { pathname } = useLocation();

  // const ScrollToTop = () => {

  //   if ("scrollRestoration" in window.history) {
  //     window.history.scrollRestoration = "manual";
  //   }

  //   useEffect(() => {
  //     setTimeout(() => {
  //       window.scrollTo(0, 0);
  //     }, 10); // Small delay to override browser behavior
  //   }, [pathname]);

  //   return null;
  // };

  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }

      // Use requestAnimationFrame instead of setTimeout for better Safari support
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
    }, [pathname]);

    return null;
  };

//   useEffect(() => {
//   const preventDefaultOnClick = (e) => {
//     if (
//       e.target.tagName === "IMG" &&
//       !e.target.closest("a") // allow if inside a link
//     ) {
//       e.preventDefault();
//     }
//   };

//   const preventDefaultOnContext = (e) => {
//     if (e.target.tagName === "IMG") {
//       e.preventDefault(); // block long-press menu everywhere
//     }
//   };

//   document.addEventListener("click", preventDefaultOnClick, true);
//   document.addEventListener("contextmenu", preventDefaultOnContext, true);

//   return () => {
//     document.removeEventListener("click", preventDefaultOnClick, true);
//     document.removeEventListener("contextmenu", preventDefaultOnContext, true);
//   };
// }, []);




  // useEffect(() => {
  //   window.__RENDER_READY__ = true;
  // }, []);

  return (
    <>
      <ScrollToTop />
      <Provider store={store}>
        <ToastContainer />
        <MainRoutes />
      </Provider>
    </>
  );
}

export default App;
